<script setup lang="ts">
import type { Image } from '@sanity/types';
import { computed, type Component } from 'vue';
import type { ALIGNMENT } from '@pkg/sanity-utils/constants/alignment';
import type { ModularBlock } from '@pkg/sanity-utils/types/modularContentBlocks';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string,
    theme: string,
    anchorId: string,
    content: Array<ModularBlock>,
    variant?: string,
    loading: 'lazy' | 'eager';
    extraSpacing?: boolean,
    image?: Image,
    subImage?: Image,
    alignment?: ALIGNMENT,
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  theme: props.block?.theme,
  anchor: props.block?.anchorId,
  loading: props.block?.loading || 'lazy',
  alignment: props.block?.alignment,
  content: props.block?.content,
  variant: props.block?.image && props.block?.variant ? props.block?.variant : 'noImage',
  image: props.block?.image,
  subImage: props.block?.subImage,
  extraSpacing: props.block?.extraSpacing,
}));
</script>

<template>
  <component :is="props.config?.innerComponent" v-bind="data"/>
</template>
